import styled, { css } from "styled-components";

interface TrackProps {
  $xAxis?: boolean;
  $yAxis?: boolean;
}

export const Track = styled.div<TrackProps>`
  ${({ $xAxis, $yAxis }) => {
    if ($xAxis)
      return css`
        width: calc(100% - 0.4rem) !important;
        height: 0.8rem !important;
        left: 0 !important;
        bottom: 0 !important;
        padding: 0 0.2rem !important;
      `;
    if ($yAxis)
      return css`
        width: 0.8rem !important;
        height: calc(100% - 0.4rem) !important;
        top: 0 !important;
        right: 0 !important;
        padding: 0.2rem 0 !important;
      `;
  }}
  background-color: transparent !important;
  border-radius: 0 !important;
  border: none !important;
  overflow: hidden !important;
`;
